import React from 'react';
import { css } from '@emotion/react';
import { colors, fontStyles } from '../../../styles';
import ArrowBack from '../../../assets/Icons/arrowback.svg';
import { ProgressBar } from './ProgressBar';

interface AppBarProps {
  onBack: () => void;
  showBackButton?: boolean;
  showProgress?: boolean;
  progressIndex?: number;
  totalSteps?: number;
  showRightButton?: boolean;
  rightButtonText?: string;
  onRightButtonClick?: () => void;
  showTitle?: boolean;
  title?: string;
}

export const AppBar: React.FC<AppBarProps> = ({
  onBack,
  showBackButton = true,
  showProgress = false,
  progressIndex = 0,
  totalSteps = 1,
  showRightButton = false,
  rightButtonText = '',
  onRightButtonClick = undefined,
  showTitle = false,
  title = '',
}) => {
  return (
    <div
      css={css`
        padding-right: 16px;
        padding-left: 16px;
        padding-top: 8px;
        padding-bottom: 8px;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
        `}
      >
        {showBackButton && (
          <button
            onClick={onBack}
            css={css`
              width: 22px;
              height: 22px;
              margin-right: 16px;
              background: none;
              border: none;
              padding: 0;
              cursor: pointer;
            `}
          >
            <img src={ArrowBack} alt="Arrow Back" style={{ width: 22, height: 22 }} />
          </button>
        )}
        <div style={{ flex: 1 }}>
          {showProgress && <ProgressBar currentStep={progressIndex} totalSteps={totalSteps} />}
          {showTitle && title && !showProgress && (
            <h1
              css={css`
                ${fontStyles.horse};
                color: var(--text-color);
                margin: 0;
                text-align: center;
                font-weight: 500;
                margin-right: ${showBackButton ? '38px' : '0'}; /* 22px (botón) + 16px (margin) = 38px */
              `}
            >
              {title}
            </h1>
          )}
        </div>
        {showRightButton && (
          <button
            onClick={onRightButtonClick}
            css={css`
              margin-left: 16px;
              background: none;
              border: none;
              padding: 0;
              cursor: pointer;
            `}
          >
            <p
              css={css`
                ${fontStyles.flea};
                color: ${colors.silver};
                margin: 0;
              `}
            >
              {rightButtonText}
            </p>
          </button>
        )}
      </div>
    </div>
  );
};
